import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableHeader from './invoice-table-header';
import InvoiceTableRow from './invoice-table-row';
import InvoiceTableFooter from './invoice-table-footer';
import { BranchesType } from '@/services/api/type/branch.type';

interface Props {
  totalPayment: number;
  totalRemainingAmount: number;
  totalSubAmount: number;
  totalPrice: number;
  totalNLTE: string;
  totalFinalService: number;
  totalFinalServiceFee: number;
  totalFinalTax: number;
  bookingLineItems: any[];
  currentBranch: BranchesType | undefined;
}

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 4,
    borderWidth: 1,
    borderBottom: 0
  }
});

const InvoiceItemsTable = ({
  totalPayment,
  totalRemainingAmount,
  totalSubAmount,
  totalPrice,
  totalFinalService,
  totalFinalServiceFee,
  totalFinalTax,
  totalNLTE,
  bookingLineItems,
  currentBranch
}: Props) => (
  <View style={styles.tableContainer}>
    <InvoiceTableHeader />
    <InvoiceTableRow bookingLineItems={bookingLineItems} currentBranch={currentBranch} />
    <InvoiceTableFooter
      totalPayment={totalPayment}
      totalRemainingAmount={totalRemainingAmount}
      totalSubAmount={totalSubAmount}
      totalPrice={totalPrice}
      totalNLTE={totalNLTE}
      totalFinalService={totalFinalService}
      totalFinalServiceFee={totalFinalServiceFee}
      totalFinalTax={totalFinalTax}
      currentBranch={currentBranch}
    />
  </View>
);

export default InvoiceItemsTable;
